import React from 'react';
import Clone from '../../../utils/clone';

const SmallCaps: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Clone className="text-text-primary text-sm font-medium">{children}</Clone>;
};

export default SmallCaps;
